import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentLanding } from "./ContentLanding"
import {Link} from 'react-router-dom';

export const Crediti = (props) => {

  const stars = [];
  for (let i = 0; i < 60; i++) {
    stars.push(<div className="star" key={i}  />);
  }

  return(
    <div className="pages" >
      {stars}

      <div className='logoMuseo'>
        <CommonSvgContent stringToRet="logoMuseo" />
      </div>

      <div className='collaborazione'>
        <p>In collaborazione con</p>
        <h3>INAF-Osservatorio<br />
        Astronomico<br />
        di Brera </h3>
      </div>


      <div className='logo'>
        <Link to="/"><ContentLanding stringToRet="logo" /></Link>
      </div>

      <div className="content">

        <h1>Crediti</h1>
        <h2>Un progetto di</h2>
        <div className='logoMuseoInline'>
          <CommonSvgContent stringToRet="logoMuseo" />
        </div>

        <h2>In collaborazione con</h2>
        <h3>INAF-Osservatorio<br />
        Astronomico<br />
        di Brera </h3>

        <h2>Visual design e development</h2>
        <p>Marimento</p>

        <h2>Si ringrazia</h2>
        <p>Isacco Canziani (audio editing)<br />
        Lo staff del Museo e gli studenti e studentesse del Laboratorio di progettazione, produzione e comunicazione artistica e culturale della Facoltà di Arti e turismo. Laurea magistrale in arte, valorizzazione e mercato dell’Università IULM di Milano (testing)</p>

        <h2>Si ringrazia INAF - Osservatorio Astronomico di Brera <span className="light">per l'utilizzo delle seguenti immagini:</span></h2>
        <p>Fotografia di Giovanni V. Schiaparelli<br />
        Mappa di Marte autografa disegnata da Schiaparelli<br />
        Diario di osservazione di Schiaparelli<br />
        Copertina della Domenica del Corriere<br />
        Lettera di Elsa Schiaparelli<br />
        Fotografia della Cupola Schiaparelli<br />
        Lettera di Napoleone Bonaparte</p>

        <h2>Si ringrazia ARASS – Brera OdV, Associazione per il Restauro degli Antichi Strumenti Scientifici <span className="light">per l'utilizzo delle immagini del restauro del telescopio Merz-Repsold.</span></h2>

        <h2><span className="light">Per le altre immagini:</span></h2>
        <p>Lander Schiaparelli della missione ExoMars<br />
        <strong>ESA, European Space Agency (autore A. Le Floc’h)</strong></p>

        <p>Paracadute del lander Schiaparelli della missione ExoMars<br />
        <strong>NASA/JPL-Caltech/University of Arizona</strong></p>

        <p>Lander Schiaparelli in discesa su Marte<br />
        <strong>ESA, European Space Agency</strong></p>

        <p>Rover Perseverance<br />
        <strong>NASA/JPL-Caltech</strong></p>

        <p>Sezione Spazio del MUST<br />
        <strong>Museo Nazionale della Scienza e della Tecnologia Leonardo da Vinci di Milano</strong></p>

        <Link className="btn btn-danger backTo" to="/">Torna</Link>

      </div>


    </div>
  )
}
